import React, { useState } from 'react'
import { Box } from '@mui/material'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import AllRequestTable from './allRequestTable'

const AllRequestContent = () => {
  const [pendingCount, setPendingCount] = useState(null)
  const [completedCount, setCompletedCount] = useState(null)
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
        bgcolor: 'white.main',
      }}
    >
      <AdxTabsBadge scrollButtons={false}>
        <AdxTabsPanel sx={{}} label="Awaiting Approval" notification={pendingCount}>
          <AllRequestTable filter={10} setPendingCount={setPendingCount} />
        </AdxTabsPanel>
        <AdxTabsPanel sx={{}} label="Completed" notification={completedCount}>
          <AllRequestTable filter={18} setCompletedCount={setCompletedCount} />
        </AdxTabsPanel>
      </AdxTabsBadge>
    </Box>
  )
}

export default AllRequestContent
